define.alias("shared/components/shared/collapsable-info-card", "media/components/shared/collapsable-info-card");